module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1000.3b675c27.svg";